import React from 'react';
import '../styles/Dropdown.css';
import '../styles/DistanceDropdown.css';
import { CustomSlider, Input } from './';

function DistanceDropdown(props) {
    const open = props.open;
    const icon = props.icon;
    const label = props.label;
    const disabled = props.disabled;
    const sidealign = props.sidealign;
    const topalign = props.topalign;
    const toggleDropdown = props.toggleDropdown;
    const distance = props.distance;
    const onChangeDistance = props.onChangeDistance;
    const maxDistance = props.maxDistance;
    const distanceSlider = props.distanceSlider;
    const onChangeDistanceSlider = props.onChangeDistanceSlider;
    const step = props.step;

    return (
        <div className={"dropdown-outer-container relative-container " + (open === true ? "dropdown-open-container " : "dropdown-closed-container ") + (disabled === true ? "disabled" : "cursor-pointer")}>
            <div 
                className="dropdown-inner-container"
                onClick={() => toggleDropdown()}
            >
                <div className="dropdown-left-container">
                    {
                        icon === null ?
                        null
                        :
                        icon
                    }
                    <span className="body-regular colour-primary block-text text-align-left">
                        {label}
                    </span>
                </div>
                <div className="dropdown-arrow-container">
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="8" 
                        height="5" 
                        viewBox="0 0 8 5" 
                        fill="none"
                        className={"dropdown-arrow " + (open === true ? "reverse" : "")}
                    >
                        <path 
                            d="M4 5L7.4641 0.5H0.535898L4 5Z" 
                            fill="#292621"
                        />
                    </svg>
                </div>
            </div>
            {
                open === true &&
                <div className={"distance-dropdown-options-container " + (sidealign === "left" ? "dropdown-options-align-left " : "dropdown-options-align-right ") + (topalign === "bottom" ? "dropdown-options-align-bottom" : "dropdown-options-align-top")}>
                    <div className="distance-dropdown-element">
                        <Input
                            label={"Max distance"}
                            labelType={"default"}
                            info={false}
                            value={distance}
                            onChange={(text) => onChangeDistance(text.target.value)}
                            placeholder={"0.5"}
                            type="text"
                            leftUnit={null}
                            rightUnit={"mi"}
                            unitSwitch={false}
                            leftUnitSelected={true}
                            unitSwitchFunc={null}
                            disabled={false}
                            multiline={false}
                            error={false}
                            onMouseEnter={null}
                            onMouseLeave={null}
                            reset={false}
                            resetFunc={null}
                            resetPosition={null}
                            focusMultiline={false}
                            prompt={false}
                        />
                        <span className="body-regular colour-secondary block-text text-italic">
                            {maxDistance} mile{maxDistance === 1 ? "" : "s"} max
                        </span>
                    </div>
                    <div className="distance-dropdown-slider-container">
                        <CustomSlider
                            disabled={false}
                            value={distanceSlider}
                            label=""
                            onChange={onChangeDistanceSlider}
                            min={0}
                            max={maxDistance}
                            step={step}
                        />
                    </div>
                    {
                        distance === "" || distance === maxDistance ?
                        null
                        :
                        <div 
                            className="distance-dropdown-element"
                            onClick={() => onChangeDistance("")}
                        >
                            <span className="body-regular-underline colour-primary">
                                Reset
                            </span>
                        </div>
                    }
                </div>
            }
        </div>
    )
};

export default DistanceDropdown;